import { LEAD_IMPRESSION_FIELD_NAMES } from 'Constants/tracking';
import { CTA_TYPE } from 'Constants/chat';
import { isEmpty } from 'Helpers/objects';

export const addAdvertisingTag = marketConfig => {
    const baxter = marketConfig.get('advertising');
    const file = marketConfig.get('siteCode');

    /* global window */
    if (baxter.enabled) {
        window.addEventListener('firstTrackingCreated', () => {
            const element = document.createElement('script');

            element.type = 'text/javascript';
            element.src = `${baxter.host}${baxter.baxterPath}${file}${baxter.fileExt}`;
            element.id = 'baxter-script';
            element.defer = true;

            document.body.appendChild(element);

            // Load CSS File For Advertisement
            // Delete after Enabling Baxter UI/API
            const headElem = document.getElementsByTagName('head')[0];

            const linkElement = document.createElement('link');

            linkElement.id = 'baxter-style-id-'.concat(file, '.css');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = `${baxter.host}${baxter.baxterPath}${file}.css`;
            linkElement.media = 'all';
            headElem.appendChild(linkElement);
        });
    }
};

/**
 * @function isButtonVisible
 * @description Function to check if the button is visible to the user or not
 * @param {String} fieldName
 * @param {boolean} showCall
 * @param {boolean} showSeePhoneNumber
 * @param {boolean} showChat
 * @param {boolean} showInterest
 * @param {boolean} showTestDrive
 * @returns {boolean}
 */
export const isButtonVisible = (fieldName, showCall, showSeePhoneNumber, showChat, showInterest, showTestDrive) => {
    switch (fieldName) {
        case LEAD_IMPRESSION_FIELD_NAMES.PHONE:
            return showCall || showSeePhoneNumber;
        case LEAD_IMPRESSION_FIELD_NAMES.CHAT:
            return showChat;
        case LEAD_IMPRESSION_FIELD_NAMES.I_AM_INTERESTED:
            return showInterest;
        case LEAD_IMPRESSION_FIELD_NAMES.TEST_DRIVE:
            return showTestDrive;
    }
    return false;
};

/**
 * @function isIntentButtonsVisible
 * @description Function to check if the Intent button is visible to the user or not
 * @param {String} fieldName
 * @param {boolean} ctaBtns
 * @param {boolean} showCall
 * @param {boolean} showChat
 * @param {boolean} features
 * @param {boolean} showReserve
 * @param {Object} reserveFetchingData
 * @param {boolean} showChatCallIVR
 * @returns {boolean}
 */
export const isIntentButtonsVisible = (fieldName, ctaBtns, showCall, showChat, features, showReserve, reserveFetchingData, showChatCallIVR) => {
    const ctaObjLength = Object.keys(ctaBtns).length;
    const isGetStartedDisplayed = (showChatCallIVR && ctaObjLength === 2) || ctaObjLength > 2;
    const isReserveDataFetched = !showReserve || reserveFetchingData.isSuccess || reserveFetchingData.isError;

    switch (fieldName) {
        case LEAD_IMPRESSION_FIELD_NAMES.PHONE:
            return showCall;
        case LEAD_IMPRESSION_FIELD_NAMES.CHAT:
            return showChat;
        case LEAD_IMPRESSION_FIELD_NAMES.GET_STARTED:
            return isReserveDataFetched && isGetStartedDisplayed;
        case LEAD_IMPRESSION_FIELD_NAMES.I_AM_INTERESTED:
            return isReserveDataFetched && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.INTERESTED]);
        case LEAD_IMPRESSION_FIELD_NAMES.TEST_DRIVE:
            return isReserveDataFetched && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.TEST_DRIVE]);
        case LEAD_IMPRESSION_FIELD_NAMES.RESERVE:
            return !isEmpty(features.feature_flags) && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.RESERVE]);
        case LEAD_IMPRESSION_FIELD_NAMES.NOTIFY_ME:
            return !isEmpty(features.feature_flags) && !isGetStartedDisplayed && !isEmpty(ctaBtns[CTA_TYPE.NOTIFY]);
    }
    return false;
};
